import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgEditIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m17.4347 10.2904-3.7251-3.7251M3 21l3.1518-.3502c.385-.0428.5776-.0642.7575-.1224a1.86 1.86 0 0 0 .4517-.2171c.158-.1042.295-.2411.5689-.5151L20.2285 7.4966c1.0287-1.0287 1.0287-2.6965 0-3.7251s-2.6964-1.0287-3.7251 0L4.2048 16.07c-.274.274-.411.411-.515.5689a1.86 1.86 0 0 0-.2172.4517c-.0582.1799-.0796.3725-.1224.7575z"
    />
  </svg>
);
export default SvgEditIcon;
